import {Api, ApiError} from "modules/utils/Api";
import {setBETimeDiff, globalError} from "modules/actions";
import {SagaIterator} from "redux-saga";
import {call, put} from "typed-redux-saga";

export const fetchBackEndTimeSaga = function* (): SagaIterator {
	try {
		const response = yield* call(Api.Common.time);

		ApiError.CHECK(response);

		const {time} = response.success;
		const BE_TIME = new Date(time).valueOf();

		yield* put(setBETimeDiff(BE_TIME - Date.now()));
	} catch (e) {
		yield* put(globalError(e as Error));
	}
};
